module.exports = __webpack_public_path__ + "img/logo-light.7893c411.png";